
<div class="user-info-page">
  <div class="user-info-container">

    <!-- Intestazione -->
    <div class="page-heading">
      <div class="page-heading-icon">
        <i class="pi pi-user"></i>
      </div>

      <div class="page-heading-text">
        <h2>Area personale</h2>
        <p>Consulta e gestisci le informazioni del tuo profilo.</p>
      </div>
    </div>

    <!-- Avviso cambio email -->
    <div class="email-notice">
      <div class="email-notice-icon">
        <i class="pi pi-info-circle"></i>
      </div>

      <div class="email-notice-content">
        <h3>Modifica indirizzo email</h3>
        <p>
          Per richiedere il cambio dell'indirizzo email,
          contattare il supporto tecnico.
        </p>
      </div>
    </div>

    <!-- Scheda profilo -->
    <div class="profile-card">

      <div class="profile-header">
        <div class="profile-avatar">
          <i class="pi pi-user"></i>
        </div>

        <div class="profile-identity">
          <span class="profile-overline">PROFILO PERSONALE</span>
          <h3>{{ user.name }} {{ user.lastName }}</h3>
          <p>I tuoi dati anagrafici e di contatto</p>
        </div>
      </div>

      <div class="profile-body">

        <!-- Email -->
        <div class="info-row">
          <div class="info-icon">
            <i class="pi pi-envelope"></i>
          </div>

          <div class="info-content">
            <span class="info-label">Indirizzo email</span>
            <span class="info-value email-value">
              {{ user.email || 'Non disponibile' }}
            </span>
          </div>
        </div>

        <!-- Telefono -->
        <div class="info-row phone-row">
          <div class="info-icon">
            <i class="pi pi-phone"></i>
          </div>

          <div class="info-content">
            <span class="info-label">Numero di telefono</span>

            <ng-container *ngIf="!isEditingPhone; else phoneEditor">
              <span class="info-value">
                {{ user.phone || 'Non disponibile' }}
              </span>

              <button
                pButton
                type="button"
                icon="pi pi-pencil"
                label="Modifica telefono"
                class="p-button-outlined edit-phone-button"
                (click)="isEditingPhone = true"
              ></button>
            </ng-container>

            <ng-template #phoneEditor>
              <div class="phone-editor">
                <label for="user-phone">Nuovo numero di telefono</label>

                <input
                  id="user-phone"
                  pInputText
                  type="tel"
                  placeholder="Inserisci il numero di telefono"
                  [(ngModel)]="user.phone"
                  class="phone-input"
                />

                <div class="phone-editor-actions">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-check"
                    label="Salva"
                    (click)="editUser()"
                  ></button>

                  <button
                    pButton
                    type="button"
                    icon="pi pi-times"
                    label="Annulla"
                    class="p-button-outlined p-button-secondary"
                    (click)="isEditingPhone = false"
                  ></button>
                </div>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Codice convenzioni -->
        <div class="info-row">
          <div class="info-icon">
            <i class="pi pi-id-card"></i>
          </div>

          <div class="info-content">
            <span class="info-label">Codice convenzioni</span>

            <button
              *ngIf="barcodeData; else unavailableCode"
              type="button"
              class="convention-code-button"
              (click)="showBarcode = true"
              pTooltip="Visualizza il codice a barre"
              tooltipPosition="right"
              aria-label="Visualizza il codice a barre delle convenzioni"
            >
              <span>{{ user.externalCode }}</span>
              <i class="pi pi-external-link"></i>
            </button>

            <ng-template #unavailableCode>
              <span class="info-value code-value">
                {{ user.externalCode || 'Non disponibile' }}
              </span>
            </ng-template>
          </div>
        </div>

      </div>
    </div>

    <!-- Sicurezza e privacy -->
    <div class="actions-card">
      <div class="actions-heading">
        <div class="actions-heading-icon">
          <i class="pi pi-shield"></i>
        </div>

        <div>
          <h3>Sicurezza e privacy</h3>
          <p>
            Gestisci la sicurezza del tuo account e consulta le informative.
          </p>
        </div>
      </div>

      <div class="actions-grid">
        <button
          pButton
          type="button"
          icon="pi pi-lock"
          label="Cambia password"
          class="action-button"
          (click)="changePassword()"
        ></button>

        <button
          pButton
          type="button"
          icon="pi pi-file"
          label="Informativa privacy"
          class="p-button-outlined action-button privacy-button"
          (click)="showPrivacy = true"
        ></button>
      </div>
    </div>

  </div>
</div>

<!-- ========================================
     DIALOG CODICE A BARRE
======================================== -->

<p-dialog
  header="Codice Convenzione"
  [(visible)]="showBarcode"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="false"
  [showHeader]="true"
  [maximizable]="false"
  [style]="{
    width: 'min(960px, calc(100vw - 24px))',
    height: 'auto',
    maxHeight: 'calc(100vh - 24px)'
  }"
  styleClass="user-barcode-dialog"
>
  <div
    class="barcode-dialog-content"
    *ngIf="barcodeData as barcode"
  >
    <div class="barcode-dialog-graphic">
      <svg
        [attr.viewBox]="'0 0 ' + barcode.width + ' 80'"
        preserveAspectRatio="xMidYMid meet"
        role="img"
        [attr.aria-label]="'Codice a barre ' + barcode.value"
      >
        <rect
          *ngFor="let bar of barcode.bars"
          [attr.x]="bar.x"
          y="0"
          [attr.width]="bar.width"
          height="80"
          fill="#2563eb"
        ></rect>
      </svg>
    </div>

    <div class="barcode-dialog-value">
      {{ barcode.value }}
    </div>
  </div>
</p-dialog>

<!-- ========================================
     DIALOG PRIVACY
======================================== -->

<p-dialog
  header="Informativa privacy"
  [(visible)]="showPrivacy"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [dismissableMask]="false"
  [style]="{
    width: 'calc(100vw - 32px)',
    maxWidth: '700px',
    maxHeight: 'calc(100vh - 32px)'
  }"
  styleClass="user-privacy-dialog"
  (onHide)="closePrivacyDialog()"
>
  <div class="privacy-dialog-content">

    <div class="privacy-intro">
      <i class="pi pi-shield"></i>

      <div>
        <h3>Le tue preferenze sulla privacy</h3>
        <p>
          Consulta le informative e le risposte che hai fornito.
        </p>
      </div>
    </div>

    <div
      class="privacy-regulation"
      *ngFor="let regulation of user.regulations; index as index"
    >
      <h4>{{ regulation.original.title }}</h4>

      <p class="privacy-description">
        {{ regulation.original.description }}
      </p>

      <div class="privacy-answer">
        <span>Hai selezionato</span>
        <strong>{{ regulation.acceptanceAnswer }}</strong>
      </div>
    </div>

    <div
      class="privacy-empty"
      *ngIf="!user.regulations || user.regulations.length === 0"
    >
      <i class="pi pi-info-circle"></i>
      <span>Nessuna informativa disponibile.</span>
    </div>

  </div>
</p-dialog>
